import React, { Component } from 'react';
import * as UiConsts from '../../../../config/UiConstants';
import { firebaseAuth, toCurrency, pythonApiIp, logComponentLoad, logDashboardAction, serverIp } from '../../../../config/constants.js'
import axios from 'axios'
import { Button, Form, Header, Divider } from 'semantic-ui-react';
import { Link } from 'react-router-dom';
import { checkAdminEmail } from '../algoliaDashboard/AlgoliaMiscUtils';

import createBrowserHistory from 'history/createBrowserHistory';
const history = createBrowserHistory({ forceRefresh: true });


class ReceiptViewSingle extends Component {
    constructor(props) {
        super(props);
        this.state = {
            recOrderNums: [],
            receipt: '',
            loading: false,
            algoliaUser: ''
        }
    }


    componentDidMount() {
        console.log("getrx1 ++++++ componentDidMount ");

        this.removeListener = firebaseAuth().onAuthStateChanged((user) => {
            console.log("elx1 +++++++++:removeListener");

            if (user) {
                console.log("maddx241 user is:" + user.email);

                if (user.email) {
                    console.log("addx290 user.email  is:" + user.email);
                    this.setState({
                        user: user
                    })

                    //CHECK ALGOLIA FOR USER
                    checkAdminEmail(user.email, this.setAdminResult);


                }

            } else {
                console.log("rlx121 user NOT found");
                this.setState({
                    authed: false,
                    // loading: false,
                    user: user,
                    uid: user.uid
                })
            }
        })
    }


    setAdminResult = (returnObject) => {
        console.log("++++++ addx294 setAdminResult");
        //console.log("addx2941 returnObject:" + JSON.stringify(returnObject, null, 3));

        logComponentLoad(returnObject, "ReceiptViewSingle");
        this.setState({
            algoliaUser: returnObject.algoliaUser,
            //isAdmin: returnObject.isAdmin,
        })

        if (returnObject.algoliaUser.perms && returnObject.algoliaUser.perms.includes("viewReceipts") && this.props.match.params.recNum) {
            console.log("getrx2 his.props.match.params.recNum exists:" + this.props.match.params.recNum)
            this.getReceipt(this.props.match.params.recNum)
            this.setState({
                recNum: this.props.match.params.recNum
            })
        }
    }

    handleTextInputChange = (e) => {
        // console.log("hx1 >>>>: handleTextInputChange clicked");
        // console.log("hx33 e.target.type:" + e.target.type);
        console.log("hx32 e.target.name:" + e.target.name);
        console.log("hx34 e.target.value:" + e.target.value);
        let newState = {};
        newState[e.target.name] = e.target.value;

        let name = e.target.name;
        let value = e.target.value;

        this.setState(newState);

    }

    sendReceipt = () => {
        console.log("getRx31 ++++++ sendReceipt ");
        this.getReceipt(this.state.recNum)
    }

    getReceipt = (recNum) => {
        console.log("getRx12 ++++++ getReceipt ");

        this.setState({ loading: true });

        axios.post(pythonApiIp + 'getReceipt', {
            apiKey: "ad#4fsdUUddf",
            recNum: recNum
        })
            .then((response) => {
                console.log(JSON.stringify(response.data, null, 3));

                if (response.data.result) {
                    this.setState({
                        receipt: response.data.receipt,
                        recOrderNums: response.data.recOrderNums
                    });
                    logDashboardAction(this.state.user.email + " viewed Receipt " + this.props.match.params.recNum, this.state.user.email, null, "ReceiptViewSingle");
                } else {

                    this.setState({ loading: false });

                    alert(response.data.message);

                }
                this.setState({ loading: false });
                //this.resetFields();
            })
            .catch((error) => {
                console.log(error);
                this.setState({ loading: false })
            });
    }

    deleteReceipt = () => {
        console.log("getRx12 ++++++ deleteReceipt ");

        this.setState({ loading: true });

        axios.post(serverIp + 'billing/deleteReceipt', {
            apiKey: "ad#4fsdUUddf",
            idreciepts: this.state.receipt.idreciepts,
            enteredBy: this.state.user.email
        })
            .then((response) => {
                //console.log(JSON.stringify(response.data, null, 3));

                if (response.data.result) {

                    alert(response.data.message);

                    history.push("/dashboard/receipList");
                    //logDashboardAction(this.state.user.email + " deleteReceipt Receipt " + this.props.match.params.recNum, this.state.user.email, null, "ReceiptViewSingle");
                } else {

                    this.setState({ loading: false });

                    alert(response.data.message);

                }
                this.setState({ loading: false });
                //this.resetFields();
            })
            .catch((error) => {
                console.log(error);
                this.setState({ loading: false })
            });
    }

    render() {

        const orderNumbers = this.state.recOrderNums && this.state.recOrderNums.length > 0 
         ? this.state.recOrderNums.map((order) =>
            <h4>{order.order1.description} <Link to={'/dashboard/SingleOrderViewAlgolia/' + order.order_num} target="_blank">VIEW {order.order_num}</Link></h4>
        )
        :''


        const project = this.state.receipt.projectname
            ? <Header as='h3' color='olive'>
                {this.state.receipt.projectname} {this.state.receipt.largeprojects.idlargeprojects}
                <br /> <Link to={'/dashboard/viewLargeProject/' + this.state.receipt.largeprojects.idlargeprojects} target="_blank">VIEW </Link>
                <Header.Subheader>
                    Project
        </Header.Subheader>
            </Header>
            : ''

        const deleteButton = this.state.algoliaUser && this.state.algoliaUser != '' && this.state.algoliaUser.perms && this.state.algoliaUser.perms.includes("deleteReceipt")
            ? <Button color='red' onClick={this.deleteReceipt}>DELETE</Button>
            : ''

        const wholeUI = this.state.algoliaUser && this.state.algoliaUser != '' && this.state.algoliaUser.perms && this.state.algoliaUser.perms.includes("viewReceipts")
            ? <div>
                <Form onSubmit={this.sendReceipt}>
                    <Form.Field>
                        <label>{this.state.recNum}</label>
                        <Form.Input
                            name={'recNum'}
                            value={this.state.recNum}
                            placeholder='Enter Receipt Num:'
                            onChange={this.handleTextInputChange}
                            type='number'
                        />
                    </Form.Field>
                    <Button>Get Receipt</Button>
                </Form>

                <Divider horizontal>{'RECEIPT INFO'}</Divider>
                <h1> RECEIPT INFO FOR #{this.state.receipt.recieptnum}</h1>

                <Header as='h2' color='brown'>
                    {this.state.receipt.recieptnum}
                    <Header.Subheader>
                        Receipt Num
                </Header.Subheader>
                </Header>

                <Header as='h4' color='teal'>
                    {this.state.receipt.idreciepts}
                    <Header.Subheader>
                        Receipt db ID
                </Header.Subheader>
                </Header>

                <Header as='h3' color='green'>
                    {toCurrency((this.state.receipt.amountdep + this.state.receipt.amountrec))}
                    <Header.Subheader>
                        totalAmount
                </Header.Subheader>
                </Header>

                <Header as='h3' color='brown'>
                    {toCurrency(this.state.receipt.amountrec)}
                    <Header.Subheader>
                        Amount Paid On delivery
                </Header.Subheader>
                </Header>

                <Header as='h3' color='brown'>
                    {toCurrency(this.state.receipt.amountdep)}
                    <Header.Subheader>
                        Amount Paid On Deposite
                </Header.Subheader>
                </Header>

                <Header as='h3' color='red'>
                    {this.state.receipt.adminemail} / {this.state.receipt.checkstring}
                    <Header.Subheader>
                        Entered By
                </Header.Subheader>
                </Header>

                <Header as='h3' color='red'>
                    {this.state.receipt.dadate}
                    <Header.Subheader>
                        Date Delivered
                </Header.Subheader>
                </Header>

                <Header as='h3' color='red'>
                    {this.state.receipt.datestamp}
                    <Header.Subheader>
                        Date Entered
                </Header.Subheader>
                </Header>

                {project}
                <Divider horizontal>{'RECEIPT INFO'}</Divider>
                {orderNumbers}

                {deleteButton}
            </div>
            : <h4>loading error a75</h4>

        return (this.state.loading ? <UiConsts.LoadingComponent /> :
            <div>
                {wholeUI}
            </div>);
    }
}

export default ReceiptViewSingle;


// WEBPACK FOOTER //
// ./src/components/dashBoard/newDashboard/Receipts/ReceiptViewSingle.js